import { useEffect, useState } from "react";
import { CantierePicker } from "../../components/impresa/CantierePicker";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { PageHeader } from "../../components/PageHeader";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { UsersThree, Camera, ClipboardText, ArrowRight } from "@phosphor-icons/react";
import ScontrinoRapido from "../../components/impresa/ScontrinoRapido";

export default function ImpresaCantiereMode() {
  const [cantieri, setCantieri] = useState([]);
  const [sel, setSel] = useState(() => localStorage.getItem("gromapp.cantiere_mode") || "");
  useEffect(() => { api.get("/impresa/cantieri").then((r) => setCantieri(r.data.filter((c) => c.stato !== "chiuso"))).catch(() => {}); }, []);
  useEffect(() => { if (sel) localStorage.setItem("gromapp.cantiere_mode", sel); }, [sel]);
  const c = cantieri.find((x) => x.id === sel);

  const tiles = [
    { to: "/impresa/operai?vista=presenze", icon: UsersThree, t: "Presenze di oggi", d: "Chi ha lavorato e quante ore", id: "tile-presenze" },
    { to: c?.pratica_id ? `/pratiche/${c.pratica_id}` : "/impresa/cantieri", icon: Camera, t: "Scatta foto", d: "Salvate nel cantiere con data", id: "tile-foto" },
    { to: "/verbale-rapido", icon: ClipboardText, t: "Sopralluogo / Giornale", d: "Compila, fai firmare, scarica", id: "tile-verbale" },
  ];
  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="impresa-cantiere-mode">
      <PageHeader eyebrow="Impresa" title="Modalità cantiere" description={new Date().toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" })}
        actions={<Button asChild variant="ghost" size="sm"><Link to="/impresa">Gestionale completo <ArrowRight size={14} /></Link></Button>} />
      <div className="space-y-1">
        <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Cantiere</div>
        <CantierePicker cantieri={cantieri} value={sel} onChange={setSel} placeholder="— Scegli il cantiere —" vuotoLabel="" className="h-12 text-base border-slate-200 not-italic text-slate-800" mostraCommittente testId="cantiere-mode-select" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <ScontrinoRapido cantiere={c} />
        {tiles.map((t) => (
          <Link key={t.id} to={t.to} data-testid={t.id}>
            <Card className="p-5 h-full hover:shadow-md transition-shadow border-slate-200">
              <t.icon size={28} className="text-[#0B1F3A]" />
              <div className="font-heading font-bold text-lg mt-4">{t.t}</div>
              <div className="text-xs text-slate-500 mt-1">{t.d}</div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
